import React from 'react';
export const Nav30DataSource = {
    wrapper: { className: 'header3 home-page-wrapper l30y4ex3pgb-editor_css' },
    page: { className: 'home-page l30y4doiyy-editor_css' },
    logo: {
        className: 'header3-logo',
        children:
            'https://gw.alipayobjects.com/zos/basement_prod/b30cdc2a-d91c-4c78-be9c-7c63b308d4b3.svg',
    },
    Menu: {
        className: 'header3-menu',
        children: [
            {
                name: 'item0',
                className: 'header3-item',
                children: {
                    href: '#',
                    children: [
                        {
                            children: (
                                <span>
                                    <span>
                                        <p>电站数据业务</p>
                                    </span>
                                </span>
                            ),
                            name: 'text',
                            className: 'l30y55qxlgd-editor_css',
                        },
                    ],
                },
                subItem: [
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            children: [
                                {
                                    name: 'image0',
                                    className: 'item-image',
                                    children:
                                        'https://gw.alipayobjects.com/zos/rmsportal/ruHbkzzMKShUpDYMEmHM.svg',
                                },
                                {
                                    href: "/yuce",
                                    name: 'title',
                                    className: 'item-title',
                                    children: (
                                        <span>
                                            <span>
                                                <p>预测</p>
                                            </span>
                                        </span>
                                    ),
                                },
                                {
                                    name: 'content',
                                    className: 'item-content',
                                    children: '企业级 UI 设计体系',
                                },
                            ],
                        },
                    },
                ],
            },
            {
                name: 'item1',
                className: 'header3-item',
                children: {
                    href: '#',
                    children: [
                        {
                            children: (
                                <span>
                                    <span>
                                        <p>电网数据业务</p>
                                    </span>
                                </span>
                            ),
                            name: 'text',
                        },
                    ],
                },
                subItem: [
                    {
                        className: 'item-sub',
                        children: {
                            className: 'item-sub-item',
                            children: [
                                {
                                    name: 'image0',
                                    className: 'item-image',
                                    children:
                                        'https://gw.alipayobjects.com/zos/rmsportal/ruHbkzzMKShUpDYMEmHM.svg',
                                },
                                {
                                    name: 'title',
                                    className: 'item-title',
                                    children: 'Ant Design',
                                },
                                {
                                    name: 'content',
                                    className: 'item-content',
                                    children: '企业级 UI 设计体系',
                                },
                            ],
                        },
                    },
                ],
            },
            {
                name: 'item2',
                className: 'header3-item',
                children: {
                    href: '#',
                    children: [
                        {
                            children: (
                                <span>
                                    <p>能源大数据业务</p>
                                </span>
                            ),
                            name: 'text',
                        },
                    ],
                },
            },
            {
                name: 'item3',
                className: 'header3-item',
                children: {
                    href: '/',
                    children: [{ children: '首页', name: 'text' }],
                },
            },
        ],
    },
    mobileMenu: { className: 'header3-mobile-menu' },
};
export const Banner10DataSource = {
    wrapper: { className: 'banner1' },
    BannerAnim: {
        children: [
            {
                name: 'elem0',
                BannerElement: { className: 'banner-user-elem' },
                textWrapper: { className: 'banner1-text-wrapper' },
                bg: { className: 'bg bg0' },
                title: {
                    className: 'banner1-title',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/HqnZZjBjWRbjyMr.png',
                },
                content: {
                    className: 'banner1-content',
                    children: '一个高效的页面动画解决方案',
                },
                button: { className: 'banner1-button', children: 'Learn More' },
            },
            {
                name: 'elem1',
                BannerElement: { className: 'banner-user-elem' },
                textWrapper: { className: 'banner1-text-wrapper' },
                bg: { className: 'bg bg1' },
                title: {
                    className: 'banner1-title',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/HqnZZjBjWRbjyMr.png',
                },
                content: {
                    className: 'banner1-content',
                    children: '一个高效的页面动画解决方案',
                },
                button: { className: 'banner1-button', children: 'Learn More' },
            },
            {
                name: 'elem2',
                BannerElement: { className: 'banner-user-elem' },
                textWrapper: { className: 'banner1-text-wrapper' },
                bg: { className: 'bg bg1' },
                title: {
                    className: 'banner1-title',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/HqnZZjBjWRbjyMr.png',
                },
                content: {
                    className: 'banner1-content',
                    children: '一个高效的页面动画解决方案',
                },
                button: { className: 'banner1-button', children: 'Learn More' },
            },
        ],
    },
};
export const Banner20DataSource = {
    wrapper: { className: 'banner2' },
    BannerAnim: {
        children: [
            {
                name: 'elem0',
                BannerElement: { className: 'banner-user-elem' },
                page: { className: 'home-page banner2-page' },
                textWrapper: { className: 'banner2-text-wrapper' },
                bg: { className: 'bg bg0' },
                title: { className: 'banner2-title', children: 'Ant Motion' },
                content: {
                    className: 'banner2-content',
                    children: '一个高效的页面动画解决方案',
                },
                button: { className: 'banner2-button', children: 'Learn More' },
            },
        ],
    },
};
export const Banner30DataSource = {
    wrapper: { className: 'banner3' },
    textWrapper: {
        className: 'banner3-text-wrapper',
        children: [
            {
                name: 'nameEn',
                className: 'banner3-name-en',
                children: 'Seeking Experience & Engineering Conference',
            },
            {
                name: 'slogan',
                className: 'banner3-slogan',
                children: '首届蚂蚁金服体验科技大会',
                texty: true,
            },
            {
                name: 'name',
                className: 'banner3-name',
                children: '探索极致用户体验与最佳工程实践探索',
            },
            { name: 'button', className: 'banner3-button', children: '立即报名' },
            {
                name: 'time',
                className: 'banner3-time',
                children: '2018.01.06 / 中国·杭州',
            },
        ],
    },
};
export const Banner40DataSource = {
    wrapper: { className: 'home-page-wrapper banner4' },
    page: { className: 'home-page banner4-page' },
    childWrapper: {
        className: 'banner4-title-wrapper',
        children: [
            { name: 'title', children: 'Ant Design Pro', className: 'banner4-title' },
            {
                name: 'content',
                className: 'banner4-content',
                children: '开箱即用的中台前端/设计解决方案',
            },
            {
                name: 'button',
                children: { href: '#', type: 'primary', children: '开始使用' },
            },
        ],
    },
    image: {
        className: 'banner4-image',
        children:
            'https://gw.alipayobjects.com/mdn/rms/afts/img/A*k3InRLiZDk4AAAAAAAAAAABjARQnAQ',
    },
};
export const Banner50DataSource = {
    wrapper: { className: 'home-page-wrapper banner5' },
    page: { className: 'home-page banner5-page' },
    childWrapper: {
        className: 'banner5-title-wrapper',
        children: [
            { name: 'title', children: '产品名', className: 'banner5-title' },
            {
                name: 'explain',
                className: 'banner5-explain',
                children: '产品标语介绍',
            },
            {
                name: 'content',
                className: 'banner5-content',
                children: '产品的详细说明，如是什么东西之类的文字',
            },
            {
                name: 'button',
                className: 'banner5-button-wrapper',
                children: {
                    href: '#',
                    className: 'banner5-button',
                    type: 'primary',
                    children: '开始使用',
                },
            },
        ],
    },
    image: {
        className: 'banner5-image',
        children:
            'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*-wAhRYnWQscAAAAAAAAAAABkARQnAQ',
    },
};
export const Content40DataSource = {
    wrapper: { className: 'home-page-wrapper content4-wrapper' },
    page: { className: 'home-page content4' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: '蚂蚁金融云提供专业的服务',
                className: 'title-h1',
            },
            {
                name: 'content',
                className: 'title-content content4-title-content',
                children: '科技想象力，金融创造力',
            },
        ],
    },
    video: {
        className: 'content4-video',
        children: {
            video: 'https://os.alipayobjects.com/rmsportal/EejaUGsyExkXyXr.mp4',
            image: 'https://zos.alipayobjects.com/rmsportal/HZgzhugQZkqUwBVeNyfz.jpg',
        },
    },
};
export const Content50DataSource = {
    wrapper: { className: 'home-page-wrapper content5-wrapper' },
    page: { className: 'home-page content5' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            { name: 'title', children: '客户案例', className: 'title-h1' },
            {
                name: 'content',
                className: 'title-content',
                children: '在这里用一段话介绍服务的案例情况',
            },
        ],
    },
    block: {
        className: 'content5-img-wrapper',
        gutter: 16,
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
                    },
                    content: { children: 'Ant Design' },
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: { children: 'Ant Motion' },
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
                    },
                    content: { children: 'Ant Design' },
                },
            },
            {
                name: 'block3',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: { children: 'Ant Motion' },
                },
            },
            {
                name: 'block4',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
                    },
                    content: { children: 'Ant Design' },
                },
            },
            {
                name: 'block5',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: { children: 'Ant Motion' },
                },
            },
            {
                name: 'block6',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
                    },
                    content: { children: 'Ant Design' },
                },
            },
            {
                name: 'block7',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: { className: 'content5-block-content' },
                    img: {
                        children:
                            'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: { children: 'Ant Motion' },
                },
            },
        ],
    },
};
export const Content90DataSource = {
    wrapper: { className: 'home-page-wrapper content9-wrapper' },
    page: { className: 'home-page content9' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'image',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
                className: 'title-image',
            },
            { name: 'title', children: '会议日程', className: 'title-h1' },
        ],
    },
    block: {
        className: 'timeline',
        children: [
            {
                name: 'block0',
                className: 'block-wrapper',
                playScale: 0.3,
                children: {
                    imgWrapper: { className: 'image-wrapper' },
                    textWrapper: { className: 'text-wrapper' },
                    img: {
                        className: 'block-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
                    },
                    icon: {
                        className: 'block-icon',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/qJnGrvjXPxdKETlVSrbe.svg',
                    },
                    name: { className: 'block-name', children: '姓名' },
                    post: { className: 'block-post', children: '公司 职位' },
                    time: { className: 'block-time', children: '09:00 - 10:00' },
                    title: { className: 'block-title', children: '开幕致辞' },
                    content: { className: 'block-content', children: '' },
                },
            },
            {
                name: 'block1',
                className: 'block-wrapper',
                playScale: 0.3,
                children: {
                    imgWrapper: { className: 'image-wrapper' },
                    textWrapper: { className: 'text-wrapper' },
                    img: {
                        className: 'block-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
                    },
                    icon: {
                        className: 'block-icon',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
                    },
                    name: { className: 'block-name', children: '姓名' },
                    post: { className: 'block-post', children: '公司 职位' },
                    time: { className: 'block-time', children: '09:00 - 10:00' },
                    title: { className: 'block-title', children: '演示标题 - XYZ' },
                    content: {
                        className: 'block-content',
                        children:
                            '经过近 3 年的打磨，在助力中台产品研发效能提升的目标之上，包含设计语言、UI 资产、可视化以及产品体验相关的蚂蚁中台设计体系正在逐步成型。此次分享包含两部分，在介绍蚂蚁设计体系的同时，也会和大家分享我们在设计语言的部分探索。',
                    },
                },
            },
            {
                name: 'block2',
                className: 'block-wrapper',
                playScale: 0.3,
                children: {
                    imgWrapper: { className: 'image-wrapper' },
                    textWrapper: { className: 'text-wrapper' },
                    img: {
                        className: 'block-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
                    },
                    icon: {
                        className: 'block-icon',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
                    },
                    name: { className: 'block-name', children: '姓名' },
                    post: { className: 'block-post', children: '公司 职位' },
                    time: { className: 'block-time', children: '09:00 - 10:00' },
                    title: { className: 'block-title', children: '演示标题 - XYZ' },
                    content: {
                        className: 'block-content',
                        children:
                            '经过近 3 年的打磨，在助力中台产品研发效能提升的目标之上，包含设计语言、UI 资产、可视化以及产品体验相关的蚂蚁中台设计体系正在逐步成型。此次分享包含两部分，在介绍蚂蚁设计体系的同时，也会和大家分享我们在设计语言的部分探索。',
                    },
                },
            },
            {
                name: 'block3',
                className: 'block-wrapper',
                playScale: 0.3,
                children: {
                    imgWrapper: { className: 'image-wrapper' },
                    textWrapper: { className: 'text-wrapper' },
                    img: {
                        className: 'block-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
                    },
                    icon: {
                        className: 'block-icon',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
                    },
                    name: { className: 'block-name', children: '姓名' },
                    post: { className: 'block-post', children: '公司 职位' },
                    time: { className: 'block-time', children: '09:00 - 10:00' },
                    title: { className: 'block-title', children: '演示标题 - XYZ' },
                    content: {
                        className: 'block-content',
                        children:
                            '经过近 3 年的打磨，在助力中台产品研发效能提升的目标之上，包含设计语言、UI 资产、可视化以及产品体验相关的蚂蚁中台设计体系正在逐步成型。此次分享包含两部分，在介绍蚂蚁设计体系的同时，也会和大家分享我们在设计语言的部分探索。',
                    },
                },
            },
        ],
    },
};
export const Content110DataSource = {
    OverPack: {
        className: 'home-page-wrapper content11-wrapper',
        playScale: 0.3,
    },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'image',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
                className: 'title-image',
            },
            { name: 'title', children: '丰富的特色展台', className: 'title-h1' },
            {
                name: 'content',
                children:
                    '特色展台包括 Ant Design 、AntV、AntG、Egg 等明星产品，更有产品专家',
                className: 'title-content',
            },
            {
                name: 'content2',
                children: '现场问诊，为你答疑解难',
                className: 'title-content',
            },
        ],
    },
    button: {
        className: '',
        children: { a: { className: 'button', href: '#', children: '立即报名' } },
    },
};
export const Content120DataSource = {
    wrapper: { className: 'home-page-wrapper content12-wrapper' },
    page: { className: 'home-page content12' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'image',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
                className: 'title-image',
            },
            { name: 'title', children: '特别鸣谢', className: 'title-h1' },
        ],
    },
    block: {
        className: 'img-wrapper',
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'block-content' },
                    img: {
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/TFicUVisNHTOEeMYXuQF.svg',
                    },
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'block-content' },
                    img: {
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/hkLGkrlCEkGZeMQlnEkD.svg',
                    },
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'block-content' },
                    img: {
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/bqyPRSZmhvrsfJrBvASi.svg',
                    },
                },
            },
            {
                name: 'block3',
                className: 'block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'block-content' },
                    img: {
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/UcsyszzOabdCYDkoPPnM.svg',
                    },
                },
            },
            {
                name: 'block4',
                className: 'block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'block-content' },
                    img: {
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/kRBeaICGexAmVjqBEqgw.svg',
                    },
                },
            },
            {
                name: 'block5',
                className: 'block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'block-content' },
                    img: {
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/ftBIiyJcCHpHEioRvPsV.svg',
                    },
                },
            },
        ],
    },
};
export const Feature10DataSource = {
    wrapper: { className: 'home-page-wrapper content1-wrapper' },
    OverPack: { className: 'home-page content1', playScale: 0.3 },
    imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
    img: {
        children: 'https://zos.alipayobjects.com/rmsportal/nLzbeGQLPyBJoli.png',
    },
    textWrapper: { className: 'content1-text', md: 14, xs: 24 },
    title: { className: 'content1-title', children: '企业资源管理' },
    content: {
        className: 'content1-content',
        children:
            '云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。',
    },
};
export const Feature20DataSource = {
    wrapper: { className: 'home-page-wrapper content2-wrapper' },
    OverPack: { className: 'home-page content2', playScale: 0.3 },
    imgWrapper: { className: 'content2-img', md: 10, xs: 24 },
    img: {
        children: 'https://zos.alipayobjects.com/rmsportal/tvQTfCupGUFKSfQ.png',
    },
    textWrapper: { className: 'content2-text', md: 14, xs: 24 },
    title: { className: 'content2-title', children: '分布式中间件' },
    content: {
        className: 'content2-content',
        children:
            '金融级联机交易处理中间件，大规模分布式计算机，数万笔/秒级并发能力，严格保证交易数据统一性。金融级联机交易处理中间件，大规模分布式计算机，数万笔/秒级并发能力，严格保证交易数据统一性。',
    },
};
export const Feature60DataSource = {
    wrapper: { className: 'home-page-wrapper feature6-wrapper' },
    OverPack: { className: 'home-page feature6', playScale: 0.3 },
    Carousel: {
        className: 'feature6-content',
        dots: false,
        wrapper: { className: 'feature6-content-wrapper' },
        titleWrapper: {
            className: 'feature6-title-wrapper',
            barWrapper: {
                className: 'feature6-title-bar-wrapper',
                children: { className: 'feature6-title-bar' },
            },
            title: { className: 'feature6-title' },
        },
        children: [
            {
                title: { className: 'feature6-title-text', children: '服务指标' },
                className: 'feature6-item',
                name: 'block0',
                children: [
                    {
                        md: 8,
                        xs: 24,
                        className: 'feature6-number-wrapper',
                        name: 'child0',
                        number: {
                            className: 'feature6-number',
                            unit: { className: 'feature6-unit', children: '万' },
                            toText: true,
                            children: '116',
                        },
                        children: { className: 'feature6-text', children: '模型数据' },
                    },
                    {
                        md: 8,
                        xs: 24,
                        className: 'feature6-number-wrapper',
                        name: 'child1',
                        number: {
                            className: 'feature6-number',
                            unit: { className: 'feature6-unit', children: '亿' },
                            toText: true,
                            children: '1.17',
                        },
                        children: { className: 'feature6-text', children: '模型迭代数量' },
                    },
                    {
                        md: 8,
                        xs: 24,
                        className: 'feature6-number-wrapper',
                        name: 'child2',
                        number: {
                            className: 'feature6-number',
                            unit: { className: 'feature6-unit', children: '亿' },
                            toText: true,
                            children: '2.10',
                        },
                        children: { className: 'feature6-text', children: '训练样本数量' },
                    },
                ],
            },
            {
                title: { className: 'feature6-title-text', children: '服务指标' },
                className: 'feature6-item',
                name: 'block1',
                children: [
                    {
                        md: 8,
                        xs: 24,
                        name: 'child0',
                        className: 'feature6-number-wrapper',
                        number: {
                            className: 'feature6-number',
                            unit: { className: 'feature6-unit', children: '万' },
                            toText: true,
                            children: '116',
                        },
                        children: { className: 'feature6-text', children: '模型数据' },
                    },
                    {
                        md: 8,
                        xs: 24,
                        name: 'child1',
                        className: 'feature6-number-wrapper',
                        number: {
                            className: 'feature6-number',
                            unit: { className: 'feature6-unit', children: '亿' },
                            toText: true,
                            children: '1.17',
                        },
                        children: { className: 'feature6-text', children: '模型迭代数量' },
                    },
                    {
                        md: 8,
                        xs: 24,
                        name: 'child2',
                        className: 'feature6-number-wrapper',
                        number: {
                            className: 'feature6-number',
                            unit: { className: 'feature6-unit', children: '亿' },
                            toText: true,
                            children: '2.10',
                        },
                        children: { className: 'feature6-text', children: '训练样本数量' },
                    },
                ],
            },
        ],
    },
};
export const Feature01DataSource = {
    wrapper: { className: 'home-page-wrapper content0-wrapper' },
    page: { className: 'home-page content0' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [{ name: 'title', children: '产品与服务' }],
    },
    childWrapper: {
        className: 'content0-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'content0-block',
                md: 8,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:
                                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: '一站式业务接入',
                        },
                        { name: 'content', children: '支付、结算、核算接入产品效率翻四倍' },
                    ],
                },
            },
            {
                name: 'block1',
                className: 'content0-block',
                md: 8,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:
                                'https://zos.alipayobjects.com/rmsportal/YPMsLQuCEXtuEkmXTTdk.png',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: '一站式事中风险监控',
                        },
                        {
                            name: 'content',
                            children: '在所有需求配置环节事前风险控制和质量控制能力',
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'content0-block',
                md: 8,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:
                                'https://zos.alipayobjects.com/rmsportal/EkXWVvAaFJKCzhMmQYiX.png',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: '一站式数据运营',
                        },
                        {
                            name: 'content',
                            children: '沉淀产品接入效率和运营小二工作效率数据',
                        },
                    ],
                },
            },
        ],
    },
};
export const Feature71DataSource = {
    wrapper: { className: 'home-page-wrapper feature7-wrapper' },
    page: { className: 'home-page feature7' },
    OverPack: { playScale: 0.3 },
    titleWrapper: {
        className: 'feature7-title-wrapper',
        children: [
            {
                name: 'title',
                className: 'feature7-title-h1',
                children: '图像在线服务',
            },
            {
                name: 'content',
                className: 'feature7-title-content',
                children: '你可以直接快速接入图像能力',
            },
        ],
    },
    blockWrapper: {
        className: 'feature7-block-wrapper',
        gutter: 24,
        children: [
            {
                md: 6,
                xs: 24,
                name: 'block0',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
            {
                md: 6,
                xs: 24,
                name: 'block1',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
            {
                md: 6,
                xs: 24,
                name: 'block2',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
            {
                md: 6,
                xs: 24,
                name: 'block3',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
            {
                md: 6,
                xs: 24,
                name: 'block4',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
            {
                md: 6,
                xs: 24,
                name: 'block5',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
            {
                md: 6,
                xs: 24,
                name: 'block6',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
            {
                md: 6,
                xs: 24,
                name: 'block7',
                className: 'feature7-block',
                children: {
                    className: 'feature7-block-group',
                    children: [
                        {
                            name: 'image',
                            className: 'feature7-block-image',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
                        },
                        {
                            name: 'title',
                            className: 'feature7-block-title',
                            children: '身份证',
                        },
                        {
                            name: 'content',
                            className: 'feature7-block-content',
                            children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
                        },
                    ],
                },
            },
        ],
    },
};
export const Feature30DataSource = {
    wrapper: { className: 'home-page-wrapper content3-wrapper' },
    page: { className: 'home-page content3' },
    OverPack: { playScale: 0.3 },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: '蚂蚁金融云提供专业的服务',
                className: 'title-h1',
            },
            {
                name: 'content',
                className: 'title-content',
                children: '基于阿里云强大的基础资源',
            },
        ],
    },
    block: {
        className: 'content3-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'content3-block',
                md: 8,
                xs: 24,
                children: {
                    icon: {
                        className: 'content3-icon',
                        children:
                            'https://zos.alipayobjects.com/rmsportal/ScHBSdwpTkAHZkJ.png',
                    },
                    textWrapper: { className: 'content3-text' },
                    title: { className: 'content3-title', children: '企业资源管理' },
                    content: {
                        className: 'content3-content',
                        children:
                            '云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。',
                    },
                },
            },
            {
                name: 'block1',
                className: 'content3-block',
                md: 8,
                xs: 24,
                children: {
                    icon: {
                        className: 'content3-icon',
                        children:
                            'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
                    },
                    textWrapper: { className: 'content3-text' },
                    title: { className: 'content3-title', children: '云安全' },
                    content: {
                        className: 'content3-content',
                        children:
                            '按金融企业安全要求打造的完整云上安全体系，全方位保障金融应用及数据安全。',
                    },
                },
            },
            {
                name: 'block2',
                className: 'content3-block',
                md: 8,
                xs: 24,
                children: {
                    icon: {
                        className: 'content3-icon',
                        children:
                            'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
                    },
                    textWrapper: { className: 'content3-text' },
                    title: { className: 'content3-title', children: '云监控' },
                    content: {
                        className: 'content3-content',
                        children:
                            '分布式云环境集中监控，统一资源及应用状态视图，智能分析及故障定位。',
                    },
                },
            },
            {
                name: 'block3',
                className: 'content3-block',
                md: 8,
                xs: 24,
                children: {
                    icon: {
                        className: 'content3-icon',
                        children:
                            'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
                    },
                    textWrapper: { className: 'content3-text' },
                    title: { className: 'content3-title', children: '移动' },
                    content: {
                        className: 'content3-content',
                        children:
                            '一站式移动金融APP开发及全面监控；丰富可用组件，动态发布和故障热修复。',
                    },
                },
            },
            {
                name: 'block4',
                className: 'content3-block',
                md: 8,
                xs: 24,
                children: {
                    icon: {
                        className: 'content3-icon',
                        children:
                            'https://zos.alipayobjects.com/rmsportal/UsUmoBRyLvkIQeO.png',
                    },
                    textWrapper: { className: 'content3-text' },
                    title: { className: 'content3-title', children: '分布式中间件' },
                    content: {
                        className: 'content3-content',
                        children:
                            '金融级联机交易处理中间件，大规模分布式计算机，数万笔/秒级并发能力，严格保证交易数据统一性。',
                    },
                },
            },
            {
                name: 'block5',
                className: 'content3-block',
                md: 8,
                xs: 24,
                children: {
                    icon: {
                        className: 'content3-icon',
                        children:
                            'https://zos.alipayobjects.com/rmsportal/ipwaQLBLflRfUrg.png',
                    },
                    textWrapper: { className: 'content3-text' },
                    title: { className: 'content3-title', children: '大数据' },
                    content: {
                        className: 'content3-content',
                        children:
                            '一站式、全周期大数据协同工作平台，PB级数据处理、毫秒级数据分析工具。',
                    },
                },
            },
        ],
    },
};
export const Feature40DataSource = {
    wrapper: { className: 'home-page-wrapper content6-wrapper' },
    OverPack: { className: 'home-page content6' },
    textWrapper: { className: 'content6-text', xs: 24, md: 10 },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: '蚂蚁金融云提供专业的服务',
                className: 'title-h1',
            },
            {
                name: 'content',
                className: 'title-content',
                children: '基于阿里云计算强大的基础资源',
            },
        ],
    },
    img: {
        children: 'https://zos.alipayobjects.com/rmsportal/VHGOVdYyBwuyqCx.png',
        className: 'content6-img',
        xs: 24,
        md: 14,
    },
    block: {
        children: [
            {
                name: 'block0',
                img: {
                    children:
                        'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
                    className: 'content6-icon',
                },
                title: { className: 'content6-title', children: '技术' },
                content: {
                    className: 'content6-content',
                    children:
                        '丰富的技术组件，简单组装即可快速搭建金融级应用，丰富的技术组件，简单组装即可快速搭建金融级应用。',
                },
            },
            {
                name: 'block1',
                img: {
                    className: 'content6-icon',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
                },
                title: { className: 'content6-title', children: '融合' },
                content: {
                    className: 'content6-content',
                    children:
                        '解放业务及技术生产力，推动金融服务底层创新，推动金融服务底层创新。解放业务及技术生产力，推动金融服务底层创新。',
                },
            },
            {
                name: 'block2',
                img: {
                    className: 'content6-icon',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
                },
                title: { className: 'content6-title', children: '开发' },
                content: {
                    className: 'content6-content',
                    children:
                        '符合金融及要求的安全可靠、高可用、高性能的服务能力，符合金融及要求的安全可靠、高可用、高性能的服务能力。',
                },
            },
        ],
    },
};
export const Feature51DataSource = {
    wrapper: { className: 'home-page-wrapper content7-wrapper' },
    page: { className: 'home-page content7' },
    OverPack: {},
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: '蚂蚁金融云提供专业的服务',
                className: 'title-h1',
            },
            { name: 'content', children: '基于阿里云计算强大的基础资源' },
        ],
    },
    tabsWrapper: { className: 'content7-tabs-wrapper' },
    block: {
        children: [
            {
                name: 'block0',
                tag: {
                    className: 'content7-tag',
                    text: { children: 'PHONE', className: 'content7-tag-name' },
                    icon: { children: 'mobile' },
                },
                content: {
                    className: 'content7-content',
                    text: {
                        className: 'content7-text',
                        md: 14,
                        xs: 24,
                        children: (
                            <span>
                                <h3>技术</h3>
                                <p>
                                    丰富的技术组件，简单组装即可快速搭建金融级应用，丰富的技术组件，简单组装即可快速搭建金融级应用。
                                </p>
                                <br />
                                <h3>融合</h3>
                                <p>
                                    解放业务及技术生产力，推动金融服务底层创新，推动金融服务底层创新。解放业务及技术生产力，推动金融服务底层创新。
                                </p>
                                <br />
                                <h3>
                                    开放
                                </h3>符合金融及要求的安全可靠、高可用、高性能的服务能力，符合金融及要求的安全可靠、高可用、高性能的服务能力。
                            </span>
                        ),
                    },
                    img: {
                        className: 'content7-img',
                        children:
                            'https://zos.alipayobjects.com/rmsportal/xBrUaDROgtFBRRL.png',
                        md: 10,
                        xs: 24,
                    },
                },
            },
            {
                name: 'block1',
                tag: {
                    className: 'content7-tag',
                    icon: { children: 'tablet' },
                    text: { className: 'content7-tag-name', children: 'TABLET' },
                },
                content: {
                    className: 'content7-content',
                    text: {
                        className: 'content7-text',
                        md: 14,
                        xs: 24,
                        children: (
                            <span>
                                <h3>技术</h3>
                                <p>
                                    丰富的技术组件，简单组装即可快速搭建金融级应用，丰富的技术组件，简单组装即可快速搭建金融级应用。
                                </p>
                                <br />
                                <h3>融合</h3>
                                <p>
                                    解放业务及技术生产力，推动金融服务底层创新，推动金融服务底层创新。解放业务及技术生产力，推动金融服务底层创新。
                                </p>
                                <br />
                                <h3>
                                    开放
                                </h3>符合金融及要求的安全可靠、高可用、高性能的服务能力，符合金融及要求的安全可靠、高可用、高性能的服务能力。
                            </span>
                        ),
                    },
                    img: {
                        className: 'content7-img',
                        md: 10,
                        xs: 24,
                        children:
                            'https://zos.alipayobjects.com/rmsportal/xBrUaDROgtFBRRL.png',
                    },
                },
            },
            {
                name: 'block2',
                tag: {
                    className: 'content7-tag',
                    text: { children: 'DESKTOP', className: 'content7-tag-name' },
                    icon: { children: 'laptop' },
                },
                content: {
                    className: 'content7-content',
                    text: {
                        className: 'content7-text',
                        md: 14,
                        xs: 24,
                        children: (
                            <span>
                                <h3>技术</h3>
                                <p>
                                    丰富的技术组件，简单组装即可快速搭建金融级应用，丰富的技术组件，简单组装即可快速搭建金融级应用。
                                </p>
                                <br />
                                <h3>融合</h3>
                                <p>
                                    解放业务及技术生产力，推动金融服务底层创新，推动金融服务底层创新。解放业务及技术生产力，推动金融服务底层创新。
                                </p>
                                <br />
                                <h3>
                                    开放
                                </h3>符合金融及要求的安全可靠、高可用、高性能的服务能力，符合金融及要求的安全可靠、高可用、高性能的服务能力。
                            </span>
                        ),
                    },
                    img: {
                        className: 'content7-img',
                        md: 10,
                        xs: 24,
                        children:
                            'https://zos.alipayobjects.com/rmsportal/xBrUaDROgtFBRRL.png',
                    },
                },
            },
        ],
    },
};
export const Feature81DataSource = {
    wrapper: { className: 'home-page-wrapper feature8-wrapper' },
    page: { className: 'home-page feature8' },
    OverPack: { playScale: 0.3 },
    titleWrapper: {
        className: 'feature8-title-wrapper',
        children: [
            { name: 'title', className: 'feature8-title-h1', children: '使用流程' },
            {
                name: 'content',
                className: 'feature8-title-content',
                children: '流程简单清晰，快速响应需求',
            },
        ],
    },
    childWrapper: {
        className: 'feature8-button-wrapper',
        children: [
            {
                name: 'button',
                className: 'feature8-button',
                children: { href: '#', children: '立即体验' },
            },
        ],
    },
    Carousel: {
        dots: false,
        className: 'feature8-carousel',
        wrapper: { className: 'feature8-block-wrapper' },
        children: {
            className: 'feature8-block',
            titleWrapper: {
                className: 'feature8-carousel-title-wrapper',
                title: { className: 'feature8-carousel-title' },
            },
            children: [
                {
                    name: 'block0',
                    className: 'feature8-block-row',
                    gutter: 120,
                    title: {
                        className: 'feature8-carousel-title-block',
                        children: '平台自主训练流程',
                    },
                    children: [
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child0',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: '沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child1',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child2',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child3',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                    ],
                },
                {
                    name: 'block1',
                    className: 'feature8-block-row',
                    gutter: 120,
                    title: {
                        children: '平台自主训练流程',
                        className: 'feature8-carousel-title-block',
                    },
                    children: [
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child0',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: '沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child1',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child2',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child3',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                    ],
                },
            ],
        },
    },
};
export const Feature80DataSource = {
    wrapper: { className: 'home-page-wrapper feature8-wrapper' },
    page: { className: 'home-page feature8' },
    OverPack: { playScale: 0.3 },
    titleWrapper: {
        className: 'feature8-title-wrapper',
        children: [
            { name: 'title', className: 'feature8-title-h1', children: '使用流程' },
            {
                name: 'content',
                className: 'feature8-title-content',
                children: '流程简单清晰，快速响应需求',
            },
        ],
    },
    childWrapper: {
        className: 'feature8-button-wrapper',
        children: [
            {
                name: 'button',
                className: 'feature8-button',
                children: { href: '#', children: '立即体验' },
            },
        ],
    },
    Carousel: {
        dots: false,
        className: 'feature8-carousel',
        wrapper: { className: 'feature8-block-wrapper' },
        children: {
            className: 'feature8-block',
            titleWrapper: {
                className: 'feature8-carousel-title-wrapper',
                title: { className: 'feature8-carousel-title' },
            },
            children: [
                {
                    name: 'block0',
                    className: 'feature8-block-row',
                    gutter: 120,
                    title: {
                        className: 'feature8-carousel-title-block',
                        children: '平台自主训练流程',
                    },
                    children: [
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child0',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: '沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child1',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child2',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child3',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                    ],
                },
                {
                    name: 'block1',
                    className: 'feature8-block-row',
                    gutter: 120,
                    title: {
                        children: '平台自主训练流程',
                        className: 'feature8-carousel-title-block',
                    },
                    children: [
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child0',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: '沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child1',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child2',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child3',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: '需求沟通',
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children:
                                            '沟通业务需求，对接人：诚凡、芸彩沟通业务需求，对接人：诚凡、芸彩',
                                    },
                                ],
                            },
                        },
                    ],
                },
            ],
        },
    },
};
export const Pricing00DataSource = {
    wrapper: { className: 'home-page-wrapper pricing0-wrapper' },
    OverPack: { playScale: 0.3, className: 'home-page pricing0' },
    imgWrapper: { className: 'pricing0-img-wrapper', md: 12, xs: 24 },
    img: {
        className: 'pricing0-img',
        name: 'image',
        children:
            'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*OnyWT4Nsxy0AAAAAAAAAAABjARQnAQ',
    },
    childWrapper: {
        className: 'pricing0-text-wrapper',
        md: 12,
        xs: 24,
        children: [
            {
                name: 'title',
                children: 'OceanBase 服务器',
                className: 'pricing0-title',
            },
            {
                name: 'content',
                children:
                    '云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。按金融企业安全要求打造的完整云上安全体系，全方位保障金融应用及数据安全。<br/>500-5Gbps，10 GB-50TB（含），1TB流量包，国内按峰值。',
                className: 'pricing0-content',
            },
            { name: 'pricing', children: '¥2,200', className: 'pricing0-pricing' },
            {
                name: 'button',
                children: {
                    icon: 'shopping-cart',
                    href: '#',
                    type: 'primary',
                    children: '立即购买',
                },
            },
        ],
    },
};
export const Pricing10DataSource = {
    wrapper: { className: 'home-page-wrapper pricing1-wrapper' },
    page: { className: 'home-page pricing1' },
    OverPack: { playScale: 0.3, className: 'pricing1-content-wrapper' },
    titleWrapper: {
        className: 'pricing1-title-wrapper',
        children: [
            { name: 'title', children: '价目表', className: 'pricing1-title-h1' },
        ],
    },
    block: {
        className: 'pricing1-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'pricing1-block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'pricing1-block-box ' },
                    topWrapper: { className: 'pricing1-top-wrapper' },
                    name: { className: 'pricing1-name', children: 'Free' },
                    money: { className: 'pricing1-money', children: '¥0' },
                    content: {
                        className: 'pricing1-content',
                        children: (
                            <span>
                                140-500Mbps<br /> 140 GB-50TB（含）<br /> 14500GB流量包<br />{' '}
                                14国内按峰值宽带账单<br /> 14弹性计算<br /> 14云服务器 ECS{' '}
                            </span>
                        ),
                    },
                    line: { className: 'pricing1-line' },
                    buttonWrapper: {
                        className: 'pricing1-button-wrapper',
                        children: {
                            a: {
                                className: 'pricing1-button',
                                href: '#',
                                children: '免费试用',
                            },
                        },
                    },
                },
            },
            {
                name: 'block1',
                className: 'pricing1-block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'pricing1-block-box active' },
                    topWrapper: { className: 'pricing1-top-wrapper' },
                    name: { className: 'pricing1-name', children: 'Starter' },
                    money: { className: 'pricing1-money', children: '¥199' },
                    content: {
                        className: 'pricing1-content',
                        children: (
                            <span>
                                14500-5Gbps<br />1410 GB-50TB（含）<br />141TB流量包<br />14国内按峰值宽带账单<br />14弹性计算<br />云服务器
                                ECS
                            </span>
                        ),
                    },
                    line: { className: 'pricing1-line' },
                    buttonWrapper: {
                        className: 'pricing1-button-wrapper',
                        children: {
                            a: {
                                className: 'pricing1-button',
                                href: '#',
                                children: '立即购买',
                            },
                        },
                    },
                },
            },
            {
                name: 'block2',
                className: 'pricing1-block',
                md: 8,
                xs: 24,
                children: {
                    wrapper: { className: 'pricing1-block-box ' },
                    topWrapper: { className: 'pricing1-top-wrapper' },
                    name: { className: 'pricing1-name', children: 'Pro' },
                    money: { className: 'pricing1-money', children: '¥999' },
                    content: {
                        className: 'pricing1-content',
                        children: (
                            <span>
                                14大于5Gbps<br />1450 GB-100TB（含）<br />145TB流量包<br />14国内按峰值宽带账单<br />14弹性计算<br />14云服务器
                                ECS
                            </span>
                        ),
                    },
                    line: { className: 'pricing1-line' },
                    buttonWrapper: {
                        className: 'pricing1-button-wrapper',
                        children: {
                            a: {
                                className: 'pricing1-button',
                                href: '#',
                                children: '立即购买',
                            },
                        },
                    },
                },
            },
        ],
    },
};
export const Pricing20DataSource = {
    wrapper: { className: 'home-page-wrapper pricing2-wrapper' },
    page: { className: 'home-page pricing2' },
    OverPack: { playScale: 0.3, className: 'pricing2-content-wrapper' },
    titleWrapper: {
        className: 'pricing2-title-wrapper',
        children: [
            { name: 'title', children: '价目表', className: 'pricing2-title-h1' },
        ],
    },
    Table: {
        name: 'tabsTitle',
        size: 'default',
        className: 'pricing2-table',
        columns: {
            children: [
                {
                    dataIndex: 'name',
                    key: 'name',
                    name: 'empty',
                    childWrapper: {
                        children: [
                            { name: 'name', children: ' ' },
                            { name: 'content', children: ' ' },
                        ],
                    },
                },
                {
                    dataIndex: 'free',
                    key: 'free',
                    name: 'free',
                    childWrapper: {
                        className: 'pricing2-table-name-block',
                        children: [
                            {
                                name: 'name',
                                className: 'pricing2-table-name',
                                children: 'Free',
                            },
                            {
                                name: 'content',
                                className: 'pricing2-table-money',
                                children: '¥0',
                            },
                            { name: 'button', children: { href: '#', children: '免费试用' } },
                        ],
                    },
                },
                {
                    dataIndex: 'basic',
                    key: 'basic',
                    name: 'basic',
                    childWrapper: {
                        className: 'pricing2-table-name-block',
                        children: [
                            {
                                name: 'name',
                                className: 'pricing2-table-name',
                                children: 'Basic',
                            },
                            {
                                name: 'content',
                                className: 'pricing2-table-money',
                                children: '¥550',
                            },
                            { name: 'button', children: { href: '#', children: '立即购买' } },
                        ],
                    },
                },
                {
                    dataIndex: 'pro',
                    key: 'pro',
                    name: 'pro',
                    childWrapper: {
                        className: 'pricing2-table-name-block',
                        children: [
                            {
                                name: 'name',
                                className: 'pricing2-table-name',
                                children: 'Pro',
                            },
                            {
                                name: 'content',
                                className: 'pricing2-table-money',
                                children: '¥2,200',
                            },
                            {
                                name: 'button',
                                children: { href: '#', type: 'primary', children: '立即购买' },
                            },
                        ],
                    },
                },
                {
                    dataIndex: 'unlimited',
                    key: 'unlimited',
                    name: 'unlimited',
                    childWrapper: {
                        className: 'pricing2-table-name-block',
                        children: [
                            {
                                name: 'name',
                                className: 'pricing2-table-name',
                                children: 'Unlimited',
                            },
                            {
                                name: 'content',
                                className: 'pricing2-table-money',
                                children: '¥5,600',
                            },
                            { name: 'button', children: { href: '#', children: '立即购买' } },
                        ],
                    },
                },
            ],
        },
        dataSource: {
            children: [
                {
                    name: 'list0',
                    children: [
                        {
                            className: 'pricing2-table-content-name',
                            name: 'name',
                            children: '实例系列1',
                        },
                        {
                            children: 'Limited',
                            name: 'content0',
                            className: 'pricing2-table-content',
                        },
                        {
                            children: 'Unlimited',
                            name: 'content1',
                            className: 'pricing2-table-content',
                        },
                        {
                            children: 'Unlimited',
                            name: 'content2',
                            className: 'pricing2-table-content',
                        },
                        {
                            children: 'Unlimited',
                            name: 'content3',
                            className: 'pricing2-table-content',
                        },
                    ],
                },
                {
                    name: 'list1',
                    children: [
                        {
                            className: 'pricing2-table-content-name',
                            name: 'name',
                            children: '实例系列2',
                        },
                        {
                            children: 'Limited',
                            name: 'content0',
                            className: 'pricing2-table-content',
                        },
                        {
                            children: 'Unlimited',
                            name: 'content1',
                            className: 'pricing2-table-content',
                        },
                        {
                            children: 'Unlimited',
                            name: 'content2',
                            className: 'pricing2-table-content',
                        },
                        {
                            children: 'Unlimited',
                            name: 'content3',
                            className: 'pricing2-table-content',
                        },
                    ],
                },
                {
                    name: 'list2',
                    children: [
                        {
                            className: 'pricing2-table-content-name',
                            name: 'name',
                            children: '固定宽带计费',
                        },
                        {
                            name: 'content0',
                            children: '50GB',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content1',
                            children: '250GB',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content2',
                            children: '600GB',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content3',
                            children: 'Unlimited',
                            className: 'pricing2-table-content',
                        },
                    ],
                },
                {
                    name: 'list3',
                    children: [
                        {
                            className: 'pricing2-table-content-name',
                            name: 'name',
                            children: '闲置负载均衡',
                        },
                        {
                            children: '-',
                            name: 'content0',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content1',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/14ce3060-34e6-4b30-9a45-1a6b95542310.svg',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content2',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/14ce3060-34e6-4b30-9a45-1a6b95542310.svg',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content3',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/14ce3060-34e6-4b30-9a45-1a6b95542310.svg',
                            className: 'pricing2-table-content',
                        },
                    ],
                },
                {
                    name: 'list4',
                    children: [
                        {
                            className: 'pricing2-table-content-name',
                            name: 'name',
                            children: '4核',
                        },
                        {
                            name: 'content0',
                            children: '-',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content1',
                            children: '-',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content2',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/14ce3060-34e6-4b30-9a45-1a6b95542310.svg',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content3',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/14ce3060-34e6-4b30-9a45-1a6b95542310.svg',
                            className: 'pricing2-table-content',
                        },
                    ],
                },
                {
                    name: 'list5',
                    children: [
                        {
                            className: 'pricing2-table-content-name',
                            name: 'name',
                            children: '系统盘（线性计费）',
                        },
                        {
                            name: 'content0',
                            children: '-',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content1',
                            children: '-',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content2',
                            children: '-',
                            className: 'pricing2-table-content',
                        },
                        {
                            name: 'content3',
                            children:
                                'https://gw.alipayobjects.com/zos/basement_prod/14ce3060-34e6-4b30-9a45-1a6b95542310.svg',
                            className: 'pricing2-table-content',
                        },
                    ],
                },
            ],
        },
    },
};
export const Teams01DataSource = {
    wrapper: { className: 'home-page-wrapper teams0-wrapper' },
    OverPack: { playScale: 0.3, className: 'home-page teams0' },
    BannerAnim: {
        className: 'banner-anim',
        children: [
            {
                name: 'elem0',
                className: 'teams0-banner-user-elem',
                titleWrapper: {
                    className: 'teams0-content-wrapper',
                    children: [
                        {
                            name: 'image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                            className: 'teams0-image',
                        },
                        {
                            name: 'content',
                            children:
                                'SEE = Seeking Experience & Engineering，意为探索用户体验与工程实践，由蚂蚁金服集团每年举办 1-2 次，包括专业分享、产品展台、Workshop 等内容。',
                            className: 'teams0-content',
                        },
                        { name: 'title', children: '韩勇', className: 'teams0-h1' },
                        {
                            name: 'content2',
                            children: '公司+职位 信息暂缺',
                            className: 'teams0-content',
                        },
                    ],
                },
            },
            {
                name: 'elem1',
                className: 'teams0-banner-user-elem',
                titleWrapper: {
                    className: 'teams0-content-wrapper',
                    children: [
                        {
                            name: 'image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                            className: 'teams0-image',
                        },
                        {
                            name: 'content',
                            children:
                                'SEE = Seeking Experience & Engineering，意为探索用户体验与工程实践，由蚂蚁金服集团每年举办 1-2 次，包括专业分享、产品展台、Workshop 等内容。',
                            className: 'teams0-content',
                        },
                        { name: 'title', children: '叶秀英', className: 'teams0-h1' },
                        {
                            name: 'content2',
                            children: '公司+职位 信息暂缺',
                            className: 'teams0-content',
                        },
                    ],
                },
            },
        ],
    },
};
export const Teams10DataSource = {
    wrapper: { className: 'home-page-wrapper teams1-wrapper' },
    page: { className: 'home-page teams1' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [{ name: 'title', children: '团队成员' }],
    },
    block: {
        className: 'block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 8,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams1-image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams1-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams1-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams1-content',
                            children:
                                'AntV 是蚂蚁金服全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。',
                        },
                    ],
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 8,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams1-image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams1-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams1-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams1-content',
                            children:
                                '语雀是一款优雅高效的在线文档编辑与协同工具， 让每个企业轻松拥有文档中心阿里巴巴集团内部使用多年，众多中小企业首选。',
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 8,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams1-image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams1-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams1-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams1-content',
                            children:
                                'AntV 是蚂蚁金服全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。',
                        },
                    ],
                },
            },
        ],
    },
};
export const Teams20DataSource = {
    wrapper: { className: 'home-page-wrapper teams2-wrapper' },
    page: { className: 'home-page teams2' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [{ name: 'title', children: '团队成员' }],
    },
    block: {
        className: 'block-wrapper',
        gutter: 72,
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block3',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block4',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
                        },
                    ],
                },
            },
            {
                name: 'block5',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block6',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block7',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
                        },
                    ],
                },
            },
            {
                name: 'block8',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams2-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams2-textWrapper',
                    children: [
                        { name: 'title', className: 'teams2-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams2-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams2-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
        ],
    },
};
export const Teams30DataSource = {
    wrapper: { className: 'home-page-wrapper teams3-wrapper' },
    page: { className: 'home-page teams3' },
    OverPack: { playScale: 0.3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [{ name: 'title', children: '团队成员' }],
    },
    blockTop: {
        className: 'block-top-wrapper',
        children: [
            {
                name: 'block0',
                className: 'block-top',
                md: 8,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams3-top-image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                        },
                        {
                            name: 'title',
                            className: 'teams3-top-title',
                            children: '叶秀英',
                        },
                        {
                            name: 'content',
                            className: 'teams3-top-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-top-content',
                            children:
                                'AntV 是蚂蚁金服全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。',
                        },
                    ],
                },
            },
            {
                name: 'block1',
                className: 'block-top',
                md: 8,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams3-top-image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                        },
                        { name: 'title', className: 'teams3-top-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams3-top-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-top-content',
                            children:
                                '语雀是一款优雅高效的在线文档编辑与协同工具， 让每个企业轻松拥有文档中心阿里巴巴集团内部使用多年，众多中小企业首选。',
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'block-top',
                md: 8,
                xs: 24,
                titleWrapper: {
                    children: [
                        {
                            name: 'image',
                            className: 'teams3-top-image',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                        },
                        {
                            name: 'title',
                            className: 'teams3-top-title',
                            children: '叶秀英',
                        },
                        {
                            name: 'content',
                            className: 'teams3-top-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-top-content',
                            children:
                                'AntV 是蚂蚁金服全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。',
                        },
                    ],
                },
            },
        ],
    },
    block: {
        className: 'block-wrapper',
        gutter: 72,
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block3',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block4',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
                        },
                    ],
                },
            },
            {
                name: 'block5',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block6',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
            {
                name: 'block7',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '韩勇' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
                        },
                    ],
                },
            },
            {
                name: 'block8',
                className: 'block',
                md: 8,
                xs: 24,
                image: {
                    name: 'image',
                    className: 'teams3-image',
                    children:
                        'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
                },
                titleWrapper: {
                    className: 'teams3-textWrapper',
                    children: [
                        { name: 'title', className: 'teams3-title', children: '叶秀英' },
                        {
                            name: 'content',
                            className: 'teams3-job',
                            children: '公司+职位 信息暂缺',
                        },
                        {
                            name: 'content1',
                            className: 'teams3-content',
                            children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
                        },
                    ],
                },
            },
        ],
    },
};
export const Teams40DataSource = {
    wrapper: { className: 'home-page-wrapper content8-wrapper' },
    page: { className: 'home-page content8 l38iftfgm8i-editor_css' },
    OverPack: { playScale: 0.3 },
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'image',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
                className: 'title-image',
            },
            { name: 'title', children: '特邀嘉宾', className: 'title-h1' },
        ],
    },
    block: {
        className: 'content-wrapper',
        children: [
            {
                name: 'block0',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
            {
                name: 'block1',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
            {
                name: 'block2',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
            {
                name: 'block3',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
            {
                name: 'block4',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
            {
                name: 'block5',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
            {
                name: 'block6',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
            {
                name: 'block7',
                md: 6,
                xs: 24,
                className: 'content8-block-wrapper',
                children: {
                    className: 'content8-block',
                    img: {
                        className: 'content8-img',
                        children:
                            'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
                    },
                    title: { className: 'content8-title', children: 'Jack' },
                    content: {
                        className: 'content8-content',
                        children: '公司+职位 信息暂缺',
                    },
                },
            },
        ],
    },
};
export const Footer00DataSource = {
    wrapper: { className: 'home-page-wrapper footer0-wrapper' },
    OverPack: { className: 'home-page footer0', playScale: 0.05 },
    copyright: {
        className: 'copyright',
        children: (
            <span>
                ©2018 <a href="https://motion.ant.design">Ant Motion</a> All Rights
                Reserved
            </span>
        ),
    },
};
export const Footer10DataSource = {
    wrapper: { className: 'home-page-wrapper footer1-wrapper' },
    OverPack: { className: 'footer1', playScale: 0.2 },
    block: {
        className: 'home-page',
        gutter: 0,
        children: [
            {
                name: 'block0',
                xs: 24,
                md: 6,
                className: 'block',
                title: {
                    className: 'logo',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/qqaimmXZVSwAhpL.svg',
                },
                childWrapper: {
                    className: 'slogan',
                    children: [
                        {
                            name: 'content0',
                            children: 'Animation specification and components of Ant Design.',
                        },
                    ],
                },
            },
            {
                name: 'block1',
                xs: 24,
                md: 6,
                className: 'block',
                title: { children: '产品' },
                childWrapper: {
                    children: [
                        { name: 'link0', href: '#', children: '产品更新记录' },
                        { name: 'link1', href: '#', children: 'API文档' },
                        { name: 'link2', href: '#', children: '快速入门' },
                        { name: 'link3', href: '#', children: '参考指南' },
                    ],
                },
            },
            {
                name: 'block2',
                xs: 24,
                md: 6,
                className: 'block',
                title: { children: '关于' },
                childWrapper: {
                    children: [
                        { href: '#', name: 'link0', children: 'FAQ' },
                        { href: '#', name: 'link1', children: '联系我们' },
                    ],
                },
            },
            {
                name: 'block3',
                xs: 24,
                md: 6,
                className: 'block',
                title: { children: '资源' },
                childWrapper: {
                    children: [
                        { href: '#', name: 'link0', children: 'Ant Design' },
                        { href: '#', name: 'link1', children: 'Ant Motion' },
                    ],
                },
            },
        ],
    },
    copyrightWrapper: { className: 'copyright-wrapper' },
    copyrightPage: { className: 'home-page' },
    copyright: {
        className: 'copyright',
        children: (
            <span>
                ©2018 by <a href="https://motion.ant.design">Ant Motion</a> All Rights
                Reserved
            </span>
        ),
    },
};
export const Footer20DataSource = {
    wrapper: { className: 'home-page-wrapper footer2-wrapper' },
    OverPack: { className: 'home-page footer2', playScale: 0.05 },
    copyright: {
        className: 'copyright',
        children: [
            {
                name: 'image',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/NuuAwJBxewWglRSoNjET.png',
                className: 'copyright-logo',
            },
            {
                name: 'group',
                children: '蚂蚁金服体验科技大会',
                className: 'copyright-group',
            },
            {
                name: 'image2',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/fgGmQUfiUfSBfvsQpfOj.svg',
                className: 'copyright-line',
            },
            {
                name: 'copyright',
                children: 'Copyright © 蚂蚁金融服务集团',
                className: 'copyright-text',
            },
        ],
    },
    links: {
        className: 'links',
        children: [
            {
                name: 'weibo',
                href: '#',
                className: 'links-weibo',
                children:
                    'data:image/svg+xml;base64,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',
            },
            {
                name: 'zhihu',
                href: '#',
                className: 'links-zhihu',
                children:
                    'data:image/svg+xml;base64,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',
            },
        ],
    },
};
